module.exports = __webpack_public_path__ + "img/008a1c1.jpg";